var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07143 0C2.72196 0 0 2.67949 0 5.97657C0 7.09219 0.313758 8.17797 0.910748 9.1143L5.65985 16.7648C5.74087 16.8943 5.8623 16.974 6.004 16.9939C6.1962 17.0237 6.4088 16.9441 6.52007 16.7548L11.2828 9.03457C11.8494 8.1182 12.1429 7.05238 12.1429 5.97657C12.1429 2.67949 9.4209 0 6.07143 0ZM6.07143 8.96485C4.3715 8.96485 3.03571 7.61016 3.03571 5.97657C3.03571 4.33298 4.40175 2.98828 6.07143 2.98828C7.74111 2.98828 9.10714 4.33298 9.10714 5.97657C9.10714 7.6002 7.79163 8.96485 6.07143 8.96485Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07129 0V2.98831C7.74097 2.98831 9.107 4.33302 9.107 5.97662C9.107 7.60027 7.79149 8.96493 6.07129 8.96493V16.9999C6.24395 17.0038 6.42151 16.9223 6.5199 16.755L11.2826 9.03466C11.8492 8.11827 12.1427 7.05244 12.1427 5.97662C12.1427 2.67952 9.42076 0 6.07129 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.89cbf1bccd6e7266c3a6e79e87ea93fe.svg";
export { ForwardRef as ReactComponent };